/**
 * attrsForType — filtra las definiciones de atributos al subset relevante
 * para un tipo de nodo dado (misma lógica que el backend).
 *
 * Un atributo es "global" cuando applies_to_types es null, undefined o [].
 * Un atributo aplica a un nodo cuando es global O cuando el nodeType aparece
 * en applies_to_types.
 */
export function isGlobalDef(d) {
  return !d.applies_to_types || d.applies_to_types.length === 0;
}

export function attrsForType(defs, nodeType) {
  return (defs || []).filter(
    (d) => isGlobalDef(d) || (nodeType != null && (d.applies_to_types || []).includes(nodeType))
  );
}
